export let CONFIGURATION = {
  baseUrls: {
    //ServerPath: 'https://www.conversant.pro/'
    ServerPath: 'https://dev.conversant.pro/'
    // ServerPath: 'https://localhost:44360/'
  }
}
